import { render, staticRenderFns } from "./SignupConfirmation.vue?vue&type=template&id=34e9dc26&scoped=true&"
import script from "./SignupConfirmation.vue?vue&type=script&lang=js&"
export * from "./SignupConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SignupConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e9dc26",
  null
  
)

export default component.exports